/**
 * Do not edit directly
 * Generated on Thu, 13 Jan 2022 17:31:32 GMT
 */

export const Border = "#c1c6cd"; // gray-300
export const BorderSubdued = "#e0e3e6"; // gray-200
export const BorderWidth = "0.0625rem"; // 1px / 0.0625rem
export const BorderStyle = "solid"; // Solid border style
export const Gray100 = "#eef0f1";
export const Gray200 = "#e0e3e6";
export const Gray300 = "#c1c6cd";
export const Gray400 = "#929ba5";
export const Gray500 = "#67727e";
export const Gray600 = "#4e5865";
export const Gray700 = "#39424c";
export const Gray800 = "#31383f";
export const Gray900 = "#282e34";
export const Gray000 = "#f4f5f6";
export const White = "#ffffff";
export const Midnight = "#39424c";
export const Blue100 = "#dbe7ff";
export const Blue200 = "#a8c5ff";
export const Blue300 = "#699afc";
export const Blue400 = "#1a79ff";
export const Blue500 = "#0442be";
export const Blue600 = "#002e8a";
export const Blue700 = "#00246b";
export const Blue000 = "#f0f5ff";
export const Green100 = "#e6f9f2";
export const Green200 = "#adf0c9";
export const Green300 = "#70d79b";
export const Green400 = "#00bd78";
export const Green500 = "#139565";
export const Green600 = "#0d6349";
export const Green700 = "#083622";
export const Green000 = "#eefcf4";
export const Yellow100 = "#fef6d7";
export const Yellow200 = "#ffe9a8";
export const Yellow300 = "#ffd261";
export const Yellow400 = "#f2b926";
export const Yellow500 = "#c48f12";
export const Yellow600 = "#866009";
export const Yellow700 = "#423005";
export const Yellow000 = "#fefcf6";
export const Red100 = "#ffdbdb";
export const Red200 = "#ffb3b3";
export const Red300 = "#ff7a83";
export const Red400 = "#ff4751";
export const Red500 = "#cd323c";
export const Red600 = "#88202a";
export const Red700 = "#41101a";
export const Red000 = "#fff0f0";
export const Teal100 = "#dbffff";
export const Teal200 = "#9fefef";
export const Teal300 = "#55d8d4";
export const Teal400 = "#25bbb1";
export const Teal500 = "#129b9b";
export const Teal600 = "#096c71";
export const Teal700 = "#053c42";
export const Teal000 = "#f5ffff";
export const Purple100 = "#e8dbff";
export const Purple200 = "#d1adff";
export const Purple300 = "#b06bff";
export const Purple400 = "#9933ff";
export const Purple500 = "#7525cb";
export const Purple600 = "#501d8c";
export const Purple700 = "#261041";
export const Purple000 = "#f9f5ff";
export const Orange100 = "#ffdbc7";
export const Orange200 = "#ffc194";
export const Orange300 = "#fea571";
export const Orange400 = "#ee6d3a";
export const Orange500 = "#b8552e";
export const Orange600 = "#75371f";
export const Orange700 = "#412e10";
export const Orange000 = "#fff0e5";
export const Pink100 = "#ffccdd";
export const Pink200 = "#ffa3c2";
export const Pink300 = "#fd77a4";
export const Pink400 = "#ff4281";
export const Pink500 = "#bc295a";
export const Pink600 = "#8c2145";
export const Pink700 = "#4e1327";
export const Pink000 = "#fff0f5";
export const Elevation100 = "0px 1px 2px rgba(39, 45, 51, 0.05)"; // scss use only (for now)
export const Elevation200 = "0px 1px 3px rgba(39, 45, 51, 0.1), 0px 1px 2px rgba(39, 45, 51, 0.06)"; // scss use only (for now)
export const Elevation300 = "0px 4px 6px -1px rgba(39, 45, 51, 0.1), 0px 2px 4px -1px rgba(39, 45, 51, 0.06)"; // scss use only (for now)
export const Elevation400 = "0px 10px 15px -3px rgba(39, 45, 51, 0.1), 0px 4px 6px -2px rgba(39, 45, 51, 0.05)"; // scss use only (for now)
export const Elevation500 = "0px 20px 25px -5px rgba(39, 45, 51, 0.1), 0px 10px 10px -5px rgba(39, 45, 51, 0.04)"; // scss use only (for now)
export const Elevation600 = "0px 25px 50px -12px rgba(39, 45, 51, 0.25)"; // scss use only (for now)
export const ZindexHide = -1; // Z-index level
export const ZindexAuto = "auto"; // Z-index level
export const ZindexBase = 0; // Z-index level
export const ZindexDocked = 10; // Z-index level
export const ZindexDropdown = 1000; // Z-index level
export const ZindexSticky = 1100; // Z-index level
export const ZindexBanner = 1200; // Z-index level
export const ZindexOverlay = 1300; // Z-index level
export const ZindexModal = 1400; // Z-index level
export const ZindexPopover = 1500; // Z-index level
export const ZindexSkipLink = 1600; // Z-index level
export const ZindexToast = 1700; // Z-index level
export const ZindexTooltip = 1800; // Z-index level
export const Radius100 = "0.25rem"; // 4px / 0.25rem
export const Radius200 = "0.375rem"; // 6px / 0.375rem
export const Radius300 = "0.5rem"; // 8px / 0.5rem
export const Radius400 = "0.75rem"; // 12px / 0.75rem
export const Radius500 = "1rem"; // 16px / 1rem
export const Radius600 = "1.25rem"; // 20px / 1.25rem
export const Radius700 = "1.5rem"; // 24px / 1.5rem
export const RadiusDefault = "0.25rem"; // Radius 100 - 4px / 0.25rem
export const Space1 = "0.125rem"; // 2px / 0.125rem
export const Space2 = "0.25rem"; // 4px / 0.25rem
export const Space3 = "0.5rem"; // 8px / 0.5rem
export const Space4 = "1rem"; // 16px / 1rem
export const Space5 = "1.5rem"; // 24px / 1.5rem
export const Space6 = "2rem"; // 32px / 2rem
export const Space7 = "2.5rem"; // 40px / 2.5rem
export const Space8 = "3rem"; // 48px / 3rem
export const Space9 = "4rem"; // 64px / 4rem
export const Space10 = "5rem"; // 80px / 5rem
export const FontFamilySansSerif = "'Aeonik', 'Helvetica', 'Arial', sans-serif"; // Aeonik Font Stack
export const FontFamilyMonospace = "'Source Code Pro', 'Menlo', 'Monaco', 'Consolas', 'Courier New', monospace"; // Source Code Pro Font Stack
export const FontWeightNormal = 400; // 400 / normal
export const FontWeightMedium = 500; // 500 / medium
export const FontWeightBold = 700; // 700 / bold
export const FontWeightDefault = 500; // Font Weight Medium – 500 / medium
export const TextScale1 = "0.5rem"; // 8px / 0.5rem
export const TextScale2 = "0.625rem"; // 10px / 0.625rem
export const TextScale3 = "0.75rem"; // 12px / 0.75rem
export const TextScale4 = "0.875rem"; // 14px / 0.875rem
export const TextScale5 = "1rem"; // 16px / 1rem
export const TextScale6 = "1.125rem"; // 18px / 1.125rem
export const TextScale7 = "1.25rem"; // 20px / 1.25rem
export const TextScale8 = "1.5rem"; // 24px / 1.5rem
export const TextScale9 = "2rem"; // 32px / 2rem
export const TextScaleDefault = "0.875rem"; // Text Scale 4 - 14px / 0.875rem
export const TextLineHeight1 = "0.75rem"; // 12px  / 0.75rem
export const TextLineHeight2 = "1rem"; // 16px / 1rem
export const TextLineHeight3 = "1rem"; // 16px / 1rem
export const TextLineHeight4 = "1.25rem"; // 20px / 1.25rem
export const TextLineHeight5 = "1.5rem"; // 24px / 1.5rem
export const TextLineHeight6 = "1.5rem"; // 24px / 1.5rem
export const TextLineHeight7 = "1.75rem"; // 28px / 1.75rem
export const TextLineHeight8 = "2rem"; // 32px / 2rem
export const TextLineHeight9 = "2.5rem"; // 40px / 2.5rem
export const TextLineHeightDefault = "1.25rem"; // Text Line Height 4 - 20px / 1.25rem
export const TextWeight1 = 500; // Font Weight Medium – 500 / medium
export const TextWeight2 = 500; // Font Weight Medium – 500 / medium
export const TextWeight3 = 500; // Font Weight Medium – 500 / medium
export const TextWeight4 = 500; // Font Weight Medium – 500 / medium
export const TextWeight5 = 500; // Font Weight Medium – 500 / medium
export const TextWeight6 = 500; // Font Weight Medium – 500 / medium
export const TextWeight7 = 500; // Font Weight Medium – 500 / medium
export const TextWeight8 = 500; // Font Weight Medium – 500 / medium
export const TextWeight9 = 500; // Font Weight Medium – 500 / medium